import Select from "react-select";

const CountrySelect = ({ countriesList, selectedCountry, setSelectedCountry, countryFlags }) => {
  const formattedCountries = countriesList?.map((c) => ({
    value: c.countryCode,     
    label: c.name,          
    flag: countryFlags[c.countryCode],
  })) || [];

  return (
    <Select
      value={formattedCountries.find((opt) => opt.value === selectedCountry) || null}
      onChange={(option) => setSelectedCountry(option.value)}
      options={formattedCountries}

      // Liste déroulante → flag + name
      formatOptionLabel={(option) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img
            src={option.flag}
            style={{ width: "20px", height: "20px", borderRadius: "3px" }}
            alt=""
          />
          <span>{option.label}</span>
        </div>
      )}
      styles={{
        control: (base) => ({
          ...base,
          
          minHeight: 32,
          cursor: "pointer",
          color:'#454545',
          fontWeight:"500",
          fontSize:'14px',
        }),
        
      }}

    />
  );
};

export default CountrySelect;
